<template>
  <p v-if="text" class="txt-body-s-medium text-main" data-testid="notification-headline">
    {{ text }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { fieldValue } from './blockHelpers'
import type { NotificationBlock } from './types'

const props = defineProps<{
  block: NotificationBlock
}>()

const text = computed(() => fieldValue(props.block, 'text'))
</script>
